<template>
  <transition name="menu-show">
    <div v-if="isShowMenu" class="menu-box">
      <div
        class="menu-item"
        :class="pageData === 'us' ? 'mecity' : ''"
        v-for="(item, index) in menuList"
        :key="item.value"
      >
        <div
          class="menu-key"
          @click="clickHandler(index, item)"
          :class="{
            dark: isClick && menuCurIndex !== index,
            strong: isClick && menuCurIndex === index,
          }"
        >
          {{ item.text }}
        </div>
        <div class="menu-category" v-if="menuCurIndex === index">
          <div
            class="menu-category-item"
            v-for="cateItem in item.children"
            :key="cateItem.text"
          >
            <div
              v-if="item.value === 'WOMEN' || item.value === 'MEN'"
              class="menu-category-key"
            >
              {{ cateItem.text }}
            </div>
            <div
              v-else
              class="menu-category-key"
              @click="clickHandler(index, { type: 'cate', ...cateItem })"
            >
              {{ cateItem.text }}
            </div>
            <div class="menu-category-children">
              <div
                class="menu-category-children-item"
                v-html="cateChildItem.text"
                @click="
                  clickHandler(index, { type: 'cateChild', ...cateChildItem })
                "
                v-for="cateChildItem in cateItem.children"
                :key="cateChildItem.text"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      isClick: false,
      menuCurIndex: null,
    };
  },
  props: {
    isShowMenu: {
      type: Boolean,
      value: false,
    },
  },
  computed: {
    menuList() {
      return [
        {
          text: this.$t("home"),
          type: "home",
        },
        {
          text: this.$t("women"),
          value: "WOMEN",
          children: [
            {
              text: this.$t("spring22"),
              children: [
                {
                  text: this.$t("campaignSpring22"),
                  path: "/women/spring22/campaign",
                  cate: "spring22",
                },
                {
                  text: this.$t("lookbookSpring22"),
                  path: "/women/spring22/lookbook",
                  cate: "spring22",
                },
              ],
            },
            {
              text: this.$t("winter21"),
              children: [
                {
                  text: this.$t("lookbookWinter21"),
                  path: "/women/winter21/lookbook",
                  cate: "winter21",
                },
              ],
            },
            {
              text: this.$t("autumn21"),
              children: [
                {
                  text: this.$t("campaignAutumn21"),
                  path: "/women/autumn21/campaign",
                  cate: "autumn21",
                },
                {
                  text: this.$t("lookbookAutumn21"),
                  path: "/women/autumn21/lookbook",
                  cate: "autumn21",
                },
              ],
            },
          ],
        },
        {
          text: this.$t("men"),
          value: "MEN",
          children: [
            {
              text: this.$t("spring22"),
              children: [
                {
                  text: this.$t("campaignSpring22"),
                  path: "/men/spring22/campaign",
                  cate: "spring22",
                },
                {
                  text: this.$t("lookbookSpring22"),
                  path: "/men/spring22/lookbook",
                  cate: "spring22",
                },
              ],
            },
            {
              text: this.$t("winter21"),
              children: [
                {
                  text: this.$t("campaignWinter21"),
                  path: "/men/winter21/campaign",
                  cate: "winter21",
                },
                {
                  text: this.$t("lookbookWinter21"),
                  path: "/men/winter21/lookbook",
                  cate: "winter21",
                },
              ],
            },
            {
              text: this.$t("autumn21"),
              children: [
                {
                  text: this.$t("campaignAutumn21"),
                  path: "/men/autumn21/campaign",
                  cate: "autumn21",
                },
                {
                  text: this.$t("lookbookAutumn21"),
                  path: "/men/autumn21/lookbook",
                  cate: "autumn21",
                },
              ],
            },
          ],
        },
        {
          text: this.$t("stores"),
          children: [
            // {
            //   text: this.$t('conceptStores'),
            //   path: '/stores/conceptStores',
            // },
            {
              text: this.$t("otherStores"),
              path: "/stores/otherStores",
            },
          ],
        },
        {
          text: this.$t("about"),
          children: [
            {
              text: this.$t("article"),
              path: "/news/article",
            },
            {
              text: this.$t("news"),
              path: "/news/list",
            },
          ],
        },
        // {
        //   text: this.$t('lang'),
        //   type: 1
        // },
        // {
        //   text: this.$t('followUs')
        // }
      ];
    },
    pageData() {
      return this.$i18n.locale;
    },
  },
  methods: {
    clickHandler(index, data) {
      if (data.type) {
        switch (data.type) {
          case "cate":
            this.$router.push(data.path);
            break;
          case "cateChild":
            this.$router.push({
              path: data.path,
              query: { cate: data.cate },
            });
            break;
          case "home":
            this.$router.push("/");
        }
        this.$parent.clickChangeType && this.$parent.clickChangeType();
      } else {
        if (this.menuCurIndex === index) {
          this.isClick = false;
          this.menuCurIndex = null;
        } else {
          this.menuCurIndex = index;
          this.isClick = true;
        }
        // this.isClick = !this.isClick
      }
    },
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.menu-box {
  position: fixed;
  top: 58px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  font-size: 15px;
  line-height: 18px;
  z-index: 11;
  overflow: auto;
  .menu-key {
    height: 60px;
    padding-left: 18px;
    display: flex;
    align-items: center;
  }
  .menu-category-key {
    padding: 14px 0;
    padding-left: 18px;
  }
  .menu-category-item {
    margin-bottom: 5px;
  }
  .menu-category-children-item {
    padding: 14px 0;
    padding-left: 36px;
  }
  .dark {
    color: #e5e5e5;
  }
  .strong {
    font-weight: 600;
  }
  a {
    color: #424242;
  }
}
.menu-show-enter-active {
  transition: all 0.6s ease-out;
  left: 0;
}
.menu-show-leave-active {
  transition: all 0.6s ease-out;
}
.menu-show-enter,
.menu-show-leave-to {
  left: 100%;
}
</style>
